export const fieldRules = {
  required: v => !!v || 'Campo obrigatório',
  minLength3: v => v && v.length >= 3 || 'Mínimo de 3 caracteres',
}